if (!customElements.get('mms-diffuser-atc')) {
  customElements.define('mms-diffuser-atc', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.data = JSON.parse(this.querySelector('script').textContent);
      this.queue = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); }); };
      this.observer = new MutationObserver(records => {
        if (records.some(r => !(r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest('[data-mms-diffuser-price], [data-mms-diffuser-sticky]'))) this.queue();
      });
      this.observer.observe(this.root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value','style','hidden','data-oos','data-allowed','data-variant-id']});
      this.root.addEventListener('change',this.queue);this.root.addEventListener('input',this.queue);
      this.sync();
    }
    syncReviews() {
      const copy = this.root.querySelector('.mila-product-bar__identity .mila-product-bar__copy');
      const template = this.querySelector('[data-mms-sticky-review-template]');
      if (!copy || !template || copy.querySelector('[data-mms-sticky-review]')) return;
      const button = template.content.firstElementChild.cloneNode(true);
      button.addEventListener('click', () => {
        const original = this.root.querySelector('.product__title > .bundle-aggregated_reviews');
        const action = original?.querySelector('.vtl-pr-ss__inner-el') || original?.querySelector('a,button,[role="button"]') || original;
        action?.click();
      });
      copy.insertBefore(button, copy.querySelector('[data-mms-diffuser-summary]'));
    }
    syncThumbnail(variant, summary) {
      const image = this.root.querySelector('[data-mms-sticky-image]');
      if (!image) return;
      const url = variant?.image || image.dataset.fallback || '';
      if (image.dataset.selectedSource !== url) {
        image.dataset.selectedSource = url;
        image.dataset.usedFallback = 'false';
        image.hidden = !url;
        image.onerror = () => {
          image.dataset.usedFallback = 'true';
          image.alt = (this.dataset.productTitle || '') + ' product image';
          const fallback = image.dataset.fallback;
          if (fallback && image.getAttribute('src') !== fallback) image.src = fallback;
          else image.hidden = true;
        };
        if (url) image.src = url;
      }
      image.alt = variant?.imageIsVariant && image.dataset.usedFallback !== 'true' ? [this.dataset.productTitle || '', summary || ''].filter(Boolean).join(' · ') : (this.dataset.productTitle || '') + ' product image';
    }
    write(node,text) { if (node && node.textContent !== text) node.textContent = text; }
    async unitPrice(form,data) {
      const bundle = this.root.querySelector('mila-device-bundle');
      if (!bundle) {
        const variant = this.data.find(v => String(v.id) === String(data.get('id')));
        const plan = data.get('selling_plan');
        const selected = plan ? variant?.plans.find(p => String(p.id) === String(plan)) : variant;
        return selected ? {price:selected.price, compare:selected.compare} : null;
      }
      const selects = [...bundle.querySelectorAll('[data-bundle-oil]:not([disabled])')];
      if (selects.some(s => !s.value)) return;
      const fixed = bundle.dataset.fixedThree === 'true';
      const sourceId = fixed ? bundle.dataset.sourceVariant : data.get('id');
      const source = bundle.variants?.find(v => String(v.id) === String(sourceId));
      const oils = selects.map(s => ({id:s.value,name:s.selectedOptions[0]?.dataset.name}));
      const items = fixed
        ? await milaFixedThreeItems(bundle.dataset.nativeBundleMap,bundle.dataset.nativeProductId,source,oils,milaFixedBundleSellingPlan(data.get('selling_plan'),sourceId))
        : await milaEchoNativeItems(bundle.dataset.nativeBundleMap,source,Number(bundle.tierControl?.value),oils,data.get('selling_plan'));
      const id = String(items[0].id);
      if (!this.prices) this.prices = new Map();
      if (!this.prices.has(id)) {
        const url = (window.Shopify?.routes?.root || '/') + 'variants/' + id + '.js';
        const pending = fetch(url,{credentials:'same-origin'}).then(async response => {
          if (!response.ok) throw new Error('Price unavailable');
          const variant = await response.json();
          if (String(variant.id) !== id || !Number.isFinite(variant.price)) throw new Error('Price unavailable');
          return {price:variant.price,compare:variant.compare_at_price};
        }).catch(error => { this.prices.delete(id); throw error; });
        this.prices.set(id,pending);
      }
      return this.prices.get(id);
    }
    syncPreorderEta(main, purchasable, action) {
      const form = this.root.querySelector('#product-form-' + this.dataset.section);
      const bundle = this.root.querySelector('mila-device-bundle');
      const sourceId = bundle?.dataset.fixedThree === 'true' ? bundle.dataset.sourceVariant : form?.querySelector('[name="id"]')?.value;
      const hardware = this.data.find(variant => String(variant.id) === String(sourceId));
      const choices = bundle ? [...bundle.querySelectorAll('[data-bundle-oil]')].filter(select => !select.disabled && !select.closest('[data-bundle-slot]')?.hidden) : [];
      const required = bundle ? Number(bundle.tierControl?.value || 3) : 0;
      const selected = choices.slice(0, required);
      // Lead time is informational; incomplete oil choices must not hide known hardware preorder timing.
      const blockedSelection = selected.some(select => select.value && select.selectedOptions[0]?.disabled);
      const state = form?.querySelector('mms-preorder-state');
      const stateCurrent = state && String(state.dataset.variantId) === String(form?.querySelector('[name="id"]')?.value);
      const isPreorder = hardware?.preorder || selected.some(select => select.value && !select.selectedOptions[0]?.disabled && select.selectedOptions[0]?.dataset.preorder === 'true') || (stateCurrent && state.dataset.oos === 'true' && state.dataset.allowed === 'true');
      const unavailableLabel = /sold\s*out|unavailable/i.test(main.textContent || '');
      const show = Boolean(hardware?.available && !blockedSelection && !unavailableLabel && isPreorder);
      const currentButtons = [main, this.root.querySelector('[data-mms-diffuser-sticky]')].filter(Boolean);
      const reserve = show && action;
      this.root.querySelectorAll('.product-form__submit,.restock-rocket-preorder-button,[data-mms-diffuser-sticky]').forEach(button => {
        button.toggleAttribute('data-mms-reserve', reserve);
      });
      this.root.querySelectorAll('[data-mms-preorder-eta]').forEach(notice => { if (!currentButtons.some(button => button.nextElementSibling === notice) && !notice.hidden) notice.hidden = true; });
      currentButtons.forEach(button => {
        let notice = button.nextElementSibling;
        if (!notice?.hasAttribute('data-mms-preorder-eta')) {
          notice = document.createElement('p'); notice.setAttribute('data-mms-preorder-eta',''); notice.setAttribute('role','status'); notice.hidden = true;
          notice.textContent = 'Preorder: Estimated shipping in 30 to 40 days'; button.insertAdjacentElement('afterend',notice);
        }
        if (notice.hidden === show) notice.hidden = !show;
      });
    }
    renderPrice(total, compareTotal = '') {
      const native = this.root.querySelector('#ProductSubmitButton-' + this.dataset.section);
      const app = this.root.querySelector('.restock-rocket-preorder-button');
      const appStyle = app ? window.getComputedStyle(app) : null;
      const main = app && app.getClientRects().length > 0 && appStyle.display !== 'none' && appStyle.visibility !== 'hidden' ? app : native;
      if (!main) return;
      const labelNode = main.querySelector(':scope > span:not(.loading__spinner):not([data-mms-diffuser-price])');
      const text = Array.from(main.childNodes || []).filter(node => node.nodeType !== 1 || !node.matches('[data-mms-diffuser-price],.loading__spinner')).map(node => node.textContent).join(' ');
      const label = (labelNode?.textContent || text).trim().replace(/\s+/g,' ');
      const purchasable = !main.disabled && main.getAttribute('aria-disabled') !== 'true' && !main.classList.contains('loading');
      const action = /add|pre.?order|reserve/i.test(label) && !/unavailable|sold out/i.test(label);
      this.syncPreorderEta(main, purchasable, action);
      const display = purchasable && action && total ? ' — ' + total : '';
      let price = main.querySelector('[data-mms-diffuser-price]');
      if (!price) { price=document.createElement('span');price.setAttribute('data-mms-diffuser-price','');price.setAttribute('aria-live','polite');main.appendChild(price); }
      this.write(price,display);
      const sticky = this.root.querySelector('[data-mms-diffuser-sticky]');
      if (sticky) {
        let stickyLabel = sticky.querySelector('[data-mms-diffuser-sticky-label]');
        let comparison = sticky.querySelector('[data-mms-diffuser-compare]');
        if (!stickyLabel) { sticky.textContent='';stickyLabel=document.createElement('span');stickyLabel.setAttribute('data-mms-diffuser-sticky-label','');sticky.appendChild(stickyLabel); }
        if (!comparison) { comparison=document.createElement('s');comparison.setAttribute('data-mms-diffuser-compare','');sticky.appendChild(comparison); }
        this.write(stickyLabel,label + display);
        const compare = display ? compareTotal : '';
        this.write(comparison,compare);comparison.hidden=!compare;
        sticky.setAttribute('aria-label',label + display + (compare ? ', compare at ' + compare : ''));
        sticky.setAttribute('aria-disabled',String(!purchasable));
      }
    }
    async sync() {
      this.syncReviews();
      const token = this.token = (this.token || 0) + 1;
      const form = this.root.querySelector('#product-form-' + this.dataset.section);
      if (!form) return;
      const data = new FormData(form);
      const quantity = Number(data.get('quantity') || 1);
      const bundle = this.root.querySelector('mila-device-bundle');
      const sourceId = bundle?.dataset.fixedThree === 'true' ? bundle.dataset.sourceVariant : data.get('id');
      const hardware = this.data.find(variant => String(variant.id) === String(sourceId));
      const count = bundle ? Number(bundle.tierControl?.value || 3) : 0;
      const finish = hardware?.title?.split(' / ')[0] || '';
      const summary = (finish === 'Default Title' ? '' : finish) + (count ? ' · ' + count + (count === 1 ? ' oil' : ' oils') : '') + (quantity > 1 ? ' · Qty ' + quantity : '');
      this.write(this.root.querySelector('[data-mms-diffuser-summary]'), summary.replace(/^ · /,''));
      this.syncThumbnail(hardware, summary.replace(/^ · /,''));

      this.renderPrice('');
      if (!Number.isInteger(quantity) || quantity < 1) return;
      try {
        const quote = await this.unitPrice(form,data);
        const cents = quote?.price;
        if (token !== this.token || !Number.isFinite(cents) || cents < 0) return;
        const total = new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.dataset.currency}).format(cents * quantity / 100);
        const compareTotal = Number.isFinite(quote?.compare) && quote.compare > cents
          ? new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.dataset.currency}).format(quote.compare * quantity / 100) : '';
        this.renderPrice(total, compareTotal);
      } catch (_) { if (token === this.token) this.renderPrice(''); }
    }
    disconnectedCallback() { this.token++;this.observer?.disconnect();this.root?.removeEventListener('change',this.queue);this.root?.removeEventListener('input',this.queue);if(this.frame)cancelAnimationFrame(this.frame); }
  });
}

